import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { AffiliateDto } from '@/api/Affiliate/AffiliateDto'
import { NavigationHeader } from '@/components/NavigationHeader/NavigationHeader'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal'

import { AffiliateTabs } from './Details/AffiliateSlug'

export const AffiliateNavigation = ({
  isEdit,
  setEdit,
  data,
}: {
  isEdit: boolean
  setEdit: React.Dispatch<React.SetStateAction<boolean>>
  data: AffiliateDto
}): JSX.Element => {
  const navigate = useNavigate()
  const params = useParams<{
    id: string
    slug: string
  }>()
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false)
  const [keyToChange, setKeyToChange] = useState<string>('')

  const handleTabClick = (key: string) => {
    setKeyToChange(key)
    if (isEdit) {
      setConfirmationModal(true)
    } else {
      navigate(`../${key}`, { relative: 'path' })
    }
  }

  const handleTabChange = (reason: boolean) => {
    if (reason) {
      setEdit(false)
      navigate(`../${keyToChange}`, { relative: 'path' })
    }
    setConfirmationModal(false)
  }

  return (
    <div>
      <ConfirmationModal
        contentText='The page is asking you to confirm that you want to leave - data you have entered may not be saved.'
        yesButtonText='Leave Page'
        cancelButtonText='Stay on page'
        onYes={() => handleTabChange(true)}
        onCancel={() => handleTabChange(false)}
        visible={confirmationModal}
      />
      <NavigationHeader>{data && <span>{data.externalId}</span>}</NavigationHeader>
      <Tabs value={params.slug} onValueChange={handleTabClick} className='mt-2'>
        <TabsList>
          <TabsTrigger value={AffiliateTabs.DETAILS}>Details</TabsTrigger>

          <TabsTrigger value={AffiliateTabs.CLIENTS}>Clients</TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  )
}
